import { useSetState } from 'ahooks';
import { isUndefined, getSession } from '@/utils/common';
import * as SESSION_KEYS from '@/configs/session-storage-keys';
import { BSHPAProductKey } from '@/constants/productKey';

interface IReturn {
  continueButtonDisalbed: boolean;
  onChangeFormItem: (field: string, value: any) => any;
  visibilities: { [prop: string]: boolean };
  isBSHPa: boolean;
}

interface IPrams {
  (values?: any): IReturn;
}

const useFormItemReaction: IPrams = (values = {}) => {
  const [formValues, setFormValues] = useSetState<any>(values);
  const isNumberOfApplicantsUndefined = isUndefined(formValues?.applicants);
  const isInsuredNumUndefined = isUndefined(formValues?.insured_num);

  const planPicked = getSession(SESSION_KEYS.PICKED_PLAN_INFO);
  const isBSHPa = planPicked?.productKey === BSHPAProductKey;
  const isIndividual = formValues?.applicants === 'Individual';

  const ifHasInsuredNum = isBSHPa && isIndividual;

  const continueButtonDisalbed = ifHasInsuredNum
    ? isNumberOfApplicantsUndefined || isInsuredNumUndefined
    : isNumberOfApplicantsUndefined;

  const onChangeFormItem = (field: string, value: any) => {
    setFormValues({ [field]: value });
  };

  const visibilities = {
    insuredNum: ifHasInsuredNum,
  };

  return {
    continueButtonDisalbed,
    onChangeFormItem,
    visibilities,
    isBSHPa,
  };
};

export default useFormItemReaction;
